// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__jDPE2","wiggle":"Tag_wiggle__f608Y","static":"Tag_static__NbUbi","static-gray":"Tag_static-gray__Z8kP6","static-red":"Tag_static-red__uupAs"};